module.exports = __webpack_public_path__ + "img/circle-checked.f85d7bbb.svg";